export const REGION_CENTERS: Record<string, [number, number]> = {
  "서울": [126.978,37.5665], "부산":[129.0756,35.1796], "대구":[128.6014,35.8714],
  "인천":[126.7052,37.4563], "광주":[126.8526,35.1595], "대전":[127.3845,36.3504],
  "울산":[129.3114,35.5384], "세종":[127.289,36.4801], "경기":[127.009,37.275],
  "강원":[127.7298,37.8854], "충북":[127.4917,36.6357], "충남":[126.6728,36.6588],
  "전북":[127.1088,35.8204], "전남":[126.991,35.105], "경북":[128.5058,36.576],
  "경남":[128.6918,35.2383], "제주":[126.5312,33.4996]
};
export function centerFor(address: string): [number, number] {
  const key = Object.keys(REGION_CENTERS).find((name) => address.includes(name));
  return key ? REGION_CENTERS[key] : [127.7669,35.9078];
}
